import {
  SALESCHANNEL_LOADING,
  GET_SALESCHANNEL,
  GET_SALESCHANNEL_SUCCESS,
  GET_SALESCHANNEL_FAIL,
  ADD_SALESCHANNEL_SUCCESS,
  ADD_SALESCHANNEL_FAIL,
  DELETE_SALESCHANNEL_SUCCESS,
  DELETE_SALESCHANNEL_FAIL,
  UPDATE_SALESCHANNEL_SUCCESS,
  UPDATE_SALESCHANNEL_FAIL,
  SALESCHANNEL_RESET
} from "./actionType";

const INIT_STATE = {
  salesChannels: [],
  error: {},
};

const SalesChannel = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SALESCHANNEL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SALESCHANNEL:
          return {
            ...state,
            salesChannels: action.payload.data,
            isSalesChannelCreated: false,
            isSalesChannelSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SALESCHANNEL_FAIL:
      switch (action.payload.actionType) {
        case GET_SALESCHANNEL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSalesChannelCreated: false,
            isSalesChannelSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SALESCHANNEL: {
      return {
        ...state,
        isSalesChannelCreated: false,
        loading: true,
      };
    }

    case SALESCHANNEL_LOADING: {
      return {
        ...state,
        isSalesChannelCreated: false,
        loading: true,
      };
    }

    case ADD_SALESCHANNEL_SUCCESS:
      return {
        ...state,
        isSalesChannelCreated: true,
        loading: false,
        salesChannels: [action.payload.data, ...state.salesChannels],
      };

    case ADD_SALESCHANNEL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_SALESCHANNEL_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesChannelCreated: true,
        salesChannels: state.salesChannels.filter(
          salesChannel => salesChannel.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SALESCHANNEL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SALESCHANNEL_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesChannelCreated: true,
        salesChannels: state.salesChannels.map(salesChannel =>
          salesChannel.id.toString() === action.payload.data.id.toString() ? { ...salesChannel, ...action.payload.data } : salesChannel
        ),
      };

    case UPDATE_SALESCHANNEL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SALESCHANNEL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default SalesChannel;